import SavedArticle from "./SavedArticle";
export default SavedArticle;